import { commitResourceFiber, createResourceFiber, renderResourceFiber, unmountResourceFiber, } from "./core/ResourceFiber.js";
import { flushResourcesSync, UpdateScheduler } from "./core/scheduler.js";
import { tapConst } from "./hooks/tap-const.js";
import { tapMemo } from "./hooks/tap-memo.js";
import { tapEffect } from "./hooks/tap-effect.js";
import { tapEffectEvent } from "./hooks/tap-effect-event.js";
import { tapRef } from "./hooks/tap-ref.js";
export const tapSubscribableResource = (element) => {
    const scheduler = tapConst(() => new UpdateScheduler(() => {
        lastRenderRef.current = null;
        handleUpdate();
    }), []);
    const fiber = tapMemo(() => {
        void element.key;
        return createResourceFiber(element.type, (callback) => {
            if (callback()) {
                scheduler.markDirty();
            }
        });
    }, [element.type, element.key]);
    const lastRenderRef = tapRef(null);
    lastRenderRef.current = renderResourceFiber(fiber, element.props);
    const isMountedRef = tapRef(false);
    const committedPropsRef = tapRef(element.props);
    const valueRef = tapRef(lastRenderRef.current.output);
    const subscribers = tapConst(() => new Set(), []);
    const handleUpdate = tapEffectEvent(() => {
        if (!isMountedRef.current)
            return; // skip update if not mounted
        if (lastRenderRef.current === null) {
            lastRenderRef.current = renderResourceFiber(fiber, committedPropsRef.current);
        }
        if (scheduler.isDirty)
            return;
        committedPropsRef.current = lastRenderRef.current.props;
        commitResourceFiber(fiber, lastRenderRef.current);
        if (scheduler.isDirty || valueRef.current === lastRenderRef.current.output)
            return;
        valueRef.current = lastRenderRef.current.output;
        subscribers.forEach((callback) => callback());
    });
    tapEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            unmountResourceFiber(fiber);
        };
    }, [fiber]);
    tapEffect(() => {
        flushResourcesSync(handleUpdate);
    });
    return tapMemo(() => ({
        getValue: () => valueRef.current,
        subscribe: (listener) => {
            subscribers.add(listener);
            return () => subscribers.delete(listener);
        },
    }), []);
};
//# sourceMappingURL=tapSubscribableResource.js.map